export { default } from './TextWithTooltipItem';
